/**
 * @generated SignedSource<<b464a835f3e30c774a345d96809eb683>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditMainPassengers_order$data = {
  readonly orderRooms: ReadonlyArray<{
    readonly slots: ReadonlyArray<{
      readonly passenger: {
        readonly id: string;
        readonly roomPrice: number | null;
        readonly " $fragmentSpreads": FragmentRefs<"PassengerTableRow_passenger">;
      } | null;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"PassengerTableRow_orderRoom">;
  }>;
  readonly " $fragmentType": "OrderEditMainPassengers_order";
};
export type OrderEditMainPassengers_order$key = {
  readonly " $data"?: OrderEditMainPassengers_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditMainPassengers_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditMainPassengers_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderRoom",
      "kind": "LinkedField",
      "name": "orderRooms",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PassengerSlot",
          "kind": "LinkedField",
          "name": "slots",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Passenger",
              "kind": "LinkedField",
              "name": "passenger",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "roomPrice",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PassengerTableRow_passenger"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PassengerTableRow_orderRoom"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "7f9206ee1731dce6d09a471e36fdc68c";

export default node;
